import { render, staticRenderFns } from "./ProposalsGeneratedPolicies.vue?vue&type=template&id=31fa48e1"
import script from "./ProposalsGeneratedPolicies.vue?vue&type=script&lang=js"
export * from "./ProposalsGeneratedPolicies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports